import React, { useEffect, useRef, useState } from 'react';
import './Upcoming_events.css'
import Common_Title_1 from '../../common/common_components/common_title_1/Common_Title_1'
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import { Autoplay, Pagination } from 'swiper/modules';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { AllEvent, AllInsightVideo } from '../../../features/admin/common/Slice';
import { IDS } from '../../../utils/IDS';
import { encodeId, formatDate, formatTime } from '../../../utils/common';

const Upcoming_events = () => {

    const events1 = [
        {
            name: 'Environment Day Awareness',
            location: 'Om Tapovan Ashram, Borbha..',
            startdate: '4 July',
            enddate: '10 July',
            image: '/assets/images/explore/upcoming-events/event1.png'
        },
        {
            name: 'Sadguru Arpanam',
            location: 'Om Tapovan Ashram, Borbha..',
            startdate: '4 July',
            enddate: '10 July',
            image: '/assets/images/explore/upcoming-events/event2.png'
        },
        {
            name: 'Environment Day Awareness',
            location: 'Om Tapovan Ashram, Borbha..',
            startdate: '4 July',
            enddate: '10 July',
            image: '/assets/images/explore/upcoming-events/event1.png'
        },
        {
            name: 'Sadguru Arpanam',
            location: 'Om Tapovan Ashram, Borbha..',
            startdate: '4 July',
            enddate: '10 July',
            image: '/assets/images/explore/upcoming-events/event2.png'
        },
        {
            name: 'Sadguru Arpanam',
            location: 'Om Tapovan Ashram, Borbha..',
            startdate: '4 July',
            enddate: '10 July',
            image: '/assets/images/explore/upcoming-events/event2.png'
        },
    ];

    const navigate = useNavigate()

    const dispatch = useDispatch();
    const events = useSelector((state) => state.common.all_events);

    useEffect(() => {
        dispatch(AllEvent());
    }, [dispatch])





    return (
        <>
            <section className='Upcoming_events_sec'>
                <div className='container-lg'>
                    <Common_Title_1 subText={'Upcoming Shibir & Events'} link={'/all-shibir'} linktext={'See All'} />

                    <div className='slidersec'>
                        <Swiper
                            slidesPerView={1}
                            spaceBetween={10}
                            pagination={{
                                clickable: true,
                            }}
                            breakpoints={{
                                0: {
                                    slidesPerView: 1,
                                    spaceBetween: 10,
                                },
                                575: {
                                    slidesPerView: 2,
                                    spaceBetween: 10,
                                },
                                768: {
                                    slidesPerView: 3,
                                    spaceBetween: 10,
                                },
                                1024: {
                                    slidesPerView: 3,
                                    spaceBetween: 10,
                                },
                            }}
                            autoplay={{
                                delay: 2000,
                                disableOnInteraction: false,
                            }}
                            modules={[Pagination, Autoplay]}
                            className="mySwiper"
                        >
                            {events?.map((data, index) => (
                                <SwiperSlide>
                                    <div className='slider_card' onClick={() => { navigate(`/shibir-registration/${encodeId(data?.event_id)}`) }}>
                                        {/* <div className='slider_card' onClick={() => { navigate("/event-registration") }}> */}
                                        <div className='img_div'>
                                            <img className='slideimg' src={IDS.IMG_URL + data?.Event?.image} alt="event" />
                                        </div>
                                        <div className='overlayclr'></div>
                                        <div className='card_data'>
                                            <p className='eventname'>{data.name}</p>
                                            <p className='addp'><img className='calicn'
                                                src={process.env.PUBLIC_URL + '/assets/images/explore/upcoming-events/location.png'}
                                            />{[
                                                data?.Event?.Contact_us_centre?.address,
                                                data?.Event?.Contact_us_centre?.Area?.name,
                                                data?.Event?.Contact_us_centre?.City?.name,
                                                data?.Event?.Contact_us_centre?.State?.name,
                                                data?.Event?.Contact_us_centre?.Country?.name,
                                            ]
                                                .filter(Boolean)
                                                .join(", ")}
                                                {data?.Event?.Contact_us_centre?.Pincode?.name ? ` - ${data.PEvent?.Contact_us_centre?.incode.name}` : ""}</p>

                                            <p className='addp'>
                                                <img className='calicn' src={process.env.PUBLIC_URL + '/assets/images/explore/upcoming-events/calendar.png'} />
                                                <span>{formatDate(data.Event?.start_date, true)}</span> to <span>{formatDate(data.Event?.end_date, true)}</span> at {formatTime(data?.Event?.start_time) || ""}</p>
                                        </div>
                                    </div>
                                </SwiperSlide>
                            ))}


                        </Swiper>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Upcoming_events